<template>
  <div id="app">
    <div
      class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom"
    >
      <h1 class="h2 px-4">Overzicht</h1>
    </div>

    <div id="agenda" class="container-fluid px-4">
      <div class="row week d-flex flex-row align-items-center">
        <h2 class="px-3">Week {{ currentWeek }}</h2>
        <div class="text-right">
          <b-icon
            class="mx-1"
            icon="chevron-left"
            @click="previousWeek()"
          ></b-icon>
          <b-icon
            class="mx-1"
            icon="chevron-right"
            @click="nextWeek()"
          ></b-icon>
        </div>
      </div>
      <div class="row">
        <div class="col" v-for="(day, dIndex) in agenda" :key="dIndex">
          <b-card header-tag="header" footer-tag="footer">
            <template v-slot:header>
              <h6 class="mb-0">
                {{ day.date | moment("dddd") }} -
                <span class="weekDayDate">{{
                  day.date | moment("D/M/YYYY")
                }}</span>
              </h6>
            </template>
            <b-card-text>
              <div v-for="(v, index) in day.vandaag" :key="index">
                <div @click="overzichtModal(v.id, v.type)" class="o-item">
                  <!--<b>{{ v.richtuur | timeFormat }} </b>-->
                  <template v-if="v.type === 'levering'">
                    <b-badge variant="success">{{ v.type }}</b-badge>
                    <span class="date">
                      {{ v.leveringsrichtuur | timeFormat }}</span
                    >
                    <br />
                  </template>
                  <template v-else>
                    <b-badge variant="warning">{{ v.type }}</b-badge>
                    <span class="date">
                      {{ v.ophalingsrichtuur | timeFormat }}</span
                    >
                    <br />
                  </template>
                  <span v-if="v.container_info"
                    >{{ v.afval_info.naam }} ({{
                      v.container_info.grootte
                    }}
                    m³)</span
                  >
                  <br v-if="v.werf_info" />
                  <template v-if="v.gegevens_idem_klant == '0'">
                    <div v-if="v.werf_info">
                      <span
                        >{{ v.werf_info.straat }} {{ v.werf_info.huisnummer }} ,
                        {{ v.werf_info.postcode }}
                        {{ v.werf_info.gemeente }}</span
                      >
                    </div>
                  </template>
                  <template v-else>
                    <br />
                    <span
                      >{{ v.klant_info.straat }} {{ v.klant_info.huisnummer }} ,
                      {{ v.klant_info.postcode }}
                      {{ v.klant_info.gemeente }}</span
                    >
                  </template>

                  <div
                    v-if="
                      v.type === 'levering' &&
                        (v.vrachtwagen_info_levering ||
                          v.chauffeur_info_levering)
                    "
                  >
                    <span v-if="v.chauffeur_info_levering" class="sub-info">{{
                      v.chauffeur_info_levering.naam
                    }}</span>
                    <span
                      v-if="
                        v.vrachtwagen_info_levering || v.chauffeur_info_levering
                      "
                      class="sub-info"
                    >
                      -
                    </span>
                    <span v-if="v.vrachtwagen_info_levering" class="sub-info">{{
                      v.vrachtwagen_info_levering.beschrijving
                    }}</span>
                  </div>
                  <br
                    v-if="
                      v.type == 'ophaling' &&
                        (v.vrachtwagen_info_ophaling ||
                          v.chauffeur_info_ophaling)
                    "
                  />
                  <div
                    v-if="
                      v.type == 'ophaling' &&
                        (v.vrachtwagen_info_ophaling ||
                          v.chauffeur_info_ophaling)
                    "
                  >
                    <span v-if="v.chauffeur_info_ophaling" class="sub-info">{{
                      v.chauffeur_info_ophaling.naam
                    }}</span>
                    <span
                      v-if="
                        v.vrachtwagen_info_ophaling || v.chauffeur_info_ophaling
                      "
                      class="sub-info"
                    >
                      -
                    </span>
                    <span v-if="v.vrachtwagen_info_ophaling" class="sub-info">{{
                      v.vrachtwagen_info_ophaling.beschrijving
                    }}</span>
                  </div>
                  <div>
                    <p v-if="v.betalingsstatus == 'Betaald'" class="sub-info">
                      <span class="p"></span>
                      Betaald
                    </p>
                    <p v-else class="sub-info">
                      <span class="np"></span> Niet betaald
                    </p>
                  </div>
                </div>
                <hr v-if="index != Object.keys(vandaag).length - 1" />
              </div>
            </b-card-text>
          </b-card>
        </div>
      </div>
    </div>

    <!-- Modal -->
    <div
      class="modal fade"
      id="overzichtModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Bestelling</h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <div class="modal-body">
            <ul class="nav nav-tabs" role="tablist">
              <li role="presentation">
                <a
                  class="nav-link active show"
                  href="#leveringTab"
                  aria-controls="leveringTab"
                  role="tab"
                  data-toggle="tab"
                  >Levering</a
                >
              </li>
              <li role="presentation">
                <a
                  class="nav-link"
                  href="#ophalingTab"
                  aria-controls="ophalingTab"
                  role="tab"
                  data-toggle="tab"
                  >Ophaling</a
                >
              </li>
              <li role="presentation">
                <a
                  class="nav-link"
                  href="#fotosTab"
                  aria-controls="fotosTab"
                  role="tab"
                  data-toggle="tab"
                  >Foto's</a
                >
              </li>
            </ul>

            <div class="tab-content">
              <div
                role="tabpanel"
                class="tab-pane active"
                id="leveringTab"
                v-if="bestelling"
              >
                <label>Datum</label>
                <input
                  class="form-control"
                  v-model="bestelling.leveringsdatum"
                  type="text"
                />
                <label>Richtuur</label>
                <vue-timepicker
                  v-model="bestelling.leveringsrichtuur"
                  :minute-interval="15"
                ></vue-timepicker>
                <hr />
                <label>Container</label>
                <select
                  class="form-control"
                  v-model="bestelling.container"
                  disabled
                  readonly
                >
                  <option
                    v-for="container in containers"
                    :key="container.id"
                    :value="container.id"
                    :disabled="!container.beschikbaar"
                    :selected="bestelling.container"
                  >
                    {{ container.beschrijving }}
                  </option>
                </select>
                <label>Vrachtwagen</label>
                <select
                  class="form-control"
                  v-model="bestelling.leveringsvrachtwagen"
                  :disabled="utype !== 'Administrator'"
                  :readonly="utype !== 'Administrator'"
                >
                  <option
                    v-for="vrachtwagen in vrachtwagens"
                    :key="vrachtwagen.id"
                    :value="vrachtwagen.id"
                    :selected="bestelling.vrachtwagen"
                  >
                    {{ vrachtwagen.beschrijving }}
                  </option>
                </select>
                <label>Chauffeur</label>
                <select
                  class="form-control"
                  v-model="bestelling.leveringschauffeur"
                  :disabled="utype !== 'Administrator'"
                  :readonly="utype !== 'Administrator'"
                >
                  <option
                    v-for="chauffeur in chauffeurs"
                    :key="chauffeur.id"
                    :value="chauffeur.id"
                    :selected="bestelling.chauffeur"
                  >
                    {{ chauffeur.naam }}
                  </option>
                </select>
                <hr />
                <label>Klant</label>
                <select
                  class="form-control"
                  v-model="bestelling.klant"
                  disabled
                  readonly
                >
                  <option
                    v-for="klant in klanten"
                    :key="klant.id"
                    :value="klant.id"
                    :selected="bestelling.klant"
                  >
                    {{ klant.klantnaam }}
                  </option>
                </select>
                <label>Werf</label>
                <select
                  class="form-control"
                  v-model="bestelling.werf"
                  disabled
                  readonly
                >
                  <option
                    v-for="werf in werven"
                    :key="werf.id"
                    :value="werf.id"
                    :selected="bestelling.werf"
                  >
                    {{ werf.beschrijving }}
                  </option>
                </select>
                <label>Afvalproduct</label>
                <select
                  class="form-control"
                  v-model="bestelling.afvalproduct"
                  :key="bestelling.id"
                  :selected="bestelling.afvalproduct"
                  disabled
                  readonly
                >
                  <option value disabled>- Kies een afvalproduct -</option>
                  <option value="1">Gemengd afval</option>
                  <option value="2">Zuiver mengpuin</option>
                  <option value="3">Grond en stenen</option>
                  <option value="4">Bouw- en sloopafval</option>
                  <option value="5">Hout</option>
                  <option value="6">Groenafval</option>
                </select>
                <label>Notities</label>
                <textarea
                  class="form-control"
                  v-model="bestelling.notities_levering"
                  placeholder="Notities"
                  disabled
                  readonly
                ></textarea>
                <button
                  type="button"
                  class="btn btn-secondary float-right mt-2"
                  v-on:click="printVrachtbon(bestelling.id, 'plaatsing')"
                >
                  Print vrachtbon
                </button>
              </div>

              <div
                role="tabpanel"
                class="tab-pane"
                id="ophalingTab"
                v-if="bestelling"
              >
                <label>Datum</label>
                <input
                  class="form-control"
                  v-model="bestelling.ophalingsdatum"
                  type="text"
                />
                <label>Richtuur</label>
                <vue-timepicker
                  v-model="bestelling.ophalingsrichtuur"
                  :minute-interval="15"
                ></vue-timepicker>
                <hr />
                <label>Vrachtwagen</label>
                <select
                  class="form-control"
                  v-model="bestelling.ophalingsvrachtwagen"
                  :disabled="utype !== 'Administrator'"
                  :readonly="utype !== 'Administrator'"
                >
                  <option
                    v-for="vrachtwagen in vrachtwagens"
                    :key="vrachtwagen.id"
                    :value="vrachtwagen.id"
                    :selected="bestelling.vrachtwagen"
                  >
                    {{ vrachtwagen.beschrijving }}
                  </option>
                </select>
                <label>Chauffeur</label>
                <select
                  class="form-control"
                  v-model="bestelling.ophalingschauffeur"
                  :disabled="utype !== 'Administrator'"
                  :readonly="utype !== 'Administrator'"
                >
                  <option
                    v-for="chauffeur in chauffeurs"
                    :key="chauffeur.id"
                    :value="chauffeur.id"
                    :selected="bestelling.chauffeur"
                  >
                    {{ chauffeur.naam }}
                  </option>
                </select>
                <hr />
                <label>Gewicht (kg)</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="bestelling.gewicht"
                  placeholder="Gewicht"
                  readonly
                  disabled
                />
                <label>Prijs (€)</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="bestelling.prijs"
                  placeholder="Prijs"
                  disabled
                  readonly
                />
                <label>Betalingswijze</label>
                <select
                  class="form-control"
                  v-model="bestelling.betalingswijze"
                  :selected="bestelling.betalingswijze"
                  disabled
                  readonly
                >
                  <option value="Factuur">Factuur</option>
                  <option value="Contant">Contant</option>
                  <option value="Bancontact">Bancontact</option>
                </select>
                <label>Betalingsstatus</label>
                <select
                  class="form-control"
                  v-model="bestelling.betalingsstatus"
                >
                  <option value="Niet betaald">Niet betaald</option>
                  <option value="Betaald">Betaald</option>
                </select>
                <label>Opmerking</label>
                <select class="form-control" v-model="bestelling.opmerkingen">
                  <option value disabled>- Selecteer opmerking -</option>
                  <option value="Niemand aanwezig">Niemand aanwezig</option>
                  <option value="Niemand aanwezig voor betaling">
                    Niemand aanwezig voor betaling
                  </option>
                  <option value="Container boven rand geladen">
                    Container boven rand geladen
                  </option>
                  <option value="Container overladen (gewicht)">
                    Container overladen (gewicht)
                  </option>
                  <option value="Wachttijd overschreden (15min.)">
                    Wachttijd overschreden (15min.)
                  </option>
                  <option value="Container onmogelijk bereikbaar">
                    Container onmogelijk bereikbaar
                  </option>
                </select>
                <label>Notities</label>
                <textarea
                  class="form-control"
                  v-model="bestelling.notities"
                  placeholder="Notities"
                ></textarea>
                <button
                  type="button"
                  class="btn btn-secondary float-right mt-2"
                  v-on:click="printVrachtbon(bestelling.id, 'ophaling')"
                >
                  Print vrachtbon
                </button>
              </div>
              <div
                role="tabpanel"
                class="tab-pane"
                id="fotosTab"
                v-if="bestelling"
              >
                <div class="upload-container">
                  <vue-upload-multiple-image
                    @upload-success="uploadImageSuccess"
                    @before-remove="beforeRemove"
                    :data-images="bestelling.fotos"
                  ></vue-upload-multiple-image>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-primary"
              v-on:click="updateBestelling()"
            >
              Aanpassen
            </button>
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              Sluiten
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import "bootstrap";
import axios from "axios";
import _ from "lodash";

import "vue-search-select/dist/VueSearchSelect.css";

import moment from "moment";
import "moment/locale/nl-be";

import VueTimepicker from "vue2-timepicker";
import "vue2-timepicker/dist/VueTimepicker.css";

moment.updateLocale("nl-be", {
  week: {
    dow: 1, // Monday is the first day of the week
  },
});

import VueUploadMultipleImage from "vue-upload-multiple-image";

export default {
  name: "app",
  components: {
    VueTimepicker,
    VueUploadMultipleImage,
  },
  filters: {
    timeFormat(value) {
      const parts = value.split(":");
      return parts[0] + ":" + parts[1];
    },
  },
  data() {
    return {
      utype: "Administrator",
      editModalTitle: "",
      afspraken: {},
      bestelling: {},
      vandaag: [],
      morgen: [],
      week: [],
      weekTitle: "",
      currentWeek: null,
      containers: {},
      vrachtwagens: {},
      chauffeurs: {},
      klanten: [],
      werven: {},
      ophalingen: [],
      leveringen: [],
      attrs: [
        {
          key: "today",
          highlight: "red",
          dates: [],
        },
      ],
      modalType: "",
      agenda: [],
    };
  },
  mounted() {
    this.getAfspraken();
    this.getWerven();
    this.getVrachtwagens();
    this.getChauffeurs();
    this.getContainers();
  },
  methods: {
    printVrachtbon(id, type) {
      window.open(
        "https://hofman.weblion.be/api/pdf.php?b=" + id + "&type=" + type,
        "_blank"
      );
    },
    uploadImageSuccess() {
      axios
        .post("https://hofman.weblion.be/api/afbeeldingen/", {
          bestelling: this.bestelling,
        })
        .then((response) => {
          console.log(response.data);
        });
    },
    beforeRemove(index, done) {
      done();

      axios
        .post("https://hofman.weblion.be/api/afbeeldingen/", {
          bestelling: this.bestelling,
        })
        .then((response) => {
          console.log(response.data);
        });
    },
    overzichtModal(index, type) {
      this.modalType = type;
      console.log(this.modalType);
      axios
        .get("https://hofman.weblion.be/api/bestellingen/", {
          params: {
            id: index,
          },
        })
        .then((res) => {
          console.log(res.data[0]);
          this.bestelling = res.data[0];
          if (this.bestelling.betalingsstatus == "") {
            this.bestelling.betalingsstatus = "Niet betaald";
          }

          axios.get("https://hofman.weblion.be/api/klanten/").then((res) => {
            this.klanten = [res.data][0];
            console.log(this.klanten[0]);

            $("#overzichtModal").modal("show");
          });
        });
    },
    weekAgenda(week) {
      this.agenda = [];
      let currentWeek = moment().week();

      for (var d = 1; d < 7; d++) {
        let vandaagArr = [];
        let compare = moment().day(d + (week - currentWeek) * 7);

        for (var i = 0; i < this.afspraken.length; i++) {
          let ophalingsdatum = moment(this.afspraken[i]["ophalingsdatum"]);
          let leveringsdatum = moment(this.afspraken[i]["leveringsdatum"]);
          let afspraak = _.cloneDeep(this.afspraken[i]);

          //ophalen
          if (ophalingsdatum.isSame(compare, "day")) {
            let afspraak1 = _.cloneDeep(afspraak);
            afspraak1.type = "ophaling";
            afspraak1.tijdstip = moment(
              afspraak1.ophalingsdatum + " " + afspraak1.ophalingsrichtuur
            );
            vandaagArr.push(afspraak1);
          }

          //leveren
          if (leveringsdatum.isSame(compare, "day")) {
            let afspraak1 = _.cloneDeep(afspraak);
            afspraak1.type = "levering";
            afspraak1.tijdstip = moment(
              afspraak1.leveringsdatum + " " + afspraak1.leveringsrichtuur
            );
            vandaagArr.push(afspraak1);
          }
        }

        vandaagArr.sort(function(a, b) {
          return a.tijdstip - b.tijdstip;
        });

        let dag = compare;

        this.agenda.push({ date: dag, vandaag: vandaagArr });
      }
    },
    /*
    getAfspraken() {
      axios
        .get("https://hofman.weblion.be/api/bestellingen/")
        .then((response) => {
          console.log(response.data);

          this.weekTitle = "week " + moment().week();
          this.currentWeek = moment().week();

          this.afspraken = response.data;

          let vandaagArr = [];
          let morgenArr = [];
          let weekArr = [];

          for (var i = 0; i < this.afspraken.length; i++) {
            let ophalingsdatum = moment(this.afspraken[i]["ophalingsdatum"]);
            let leveringsdatum = moment(this.afspraken[i]["leveringsdatum"]);
            let afspraak = _.cloneDeep(this.afspraken[i]);

            //vandaag
            if (ophalingsdatum.isSame(moment(), "day")) {
              let afspraak1 = _.cloneDeep(afspraak);
              afspraak1.type = "ophaling";
              afspraak1.tijdstip = moment(
                afspraak1.ophalingsdatum + " " + afspraak1.ophalingsrichtuur
              );
              vandaagArr.push(afspraak1);
            }

            //vandaag
            if (leveringsdatum.isSame(moment(), "day")) {
              let afspraak1 = _.cloneDeep(afspraak);
              afspraak1.type = "levering";
              afspraak1.tijdstip = moment(
                afspraak1.leveringsdatum + " " + afspraak1.leveringsrichtuur
              );
              vandaagArr.push(afspraak1);
            }

            //morgen
            if (ophalingsdatum.isSame(moment().add(1, "days"), "day")) {
              let afspraak1 = _.cloneDeep(afspraak);
              afspraak1.type = "ophaling";
              afspraak1.tijdstip = moment(
                afspraak1.ophalingsdatum + " " + afspraak1.ophalingsrichtuur
              );
              morgenArr.push(afspraak1);
            }

            //morgen
            if (leveringsdatum.isSame(moment().add(1, "days"), "day")) {
              let afspraak1 = _.cloneDeep(afspraak);
              afspraak1.type = "levering";
              afspraak1.tijdstip = moment(
                afspraak1.leveringsdatum + " " + afspraak1.leveringsrichtuur
              );
              morgenArr.push(afspraak1);
            }

            //week

            if (
              moment(ophalingsdatum).isBetween(
                moment().startOf("week"),
                moment().endOf("week")
              )
            ) {
              let afspraak1 = _.cloneDeep(afspraak);
              afspraak1.type = "ophaling";
              afspraak1.tijdstip = moment(
                afspraak1.ophalingsdatum + " " + afspraak1.ophalingsrichtuur
              );
              weekArr.push(afspraak1);
            }

            if (
              moment(leveringsdatum).isBetween(
                moment().startOf("week"),
                moment().endOf("week")
              )
            ) {
              let afspraak1 = _.cloneDeep(afspraak);
              afspraak1.type = "levering";
              afspraak1.tijdstip = moment(
                afspraak1.leveringsdatum + " " + afspraak1.leveringsrichtuur
              );
              weekArr.push(afspraak1);
            }
          }

          this.vandaag = vandaagArr;
          this.morgen = morgenArr;
          this.week = weekArr;

          this.vandaag.sort(function(a, b) {
            return a.tijdstip - b.tijdstip;
          });

          this.morgen.sort(function(a, b) {
            return a.tijdstip - b.tijdstip;
          });

          this.week.sort(function(a, b) {
            return a.tijdstip - b.tijdstip;
          });
        })
        .catch((error) => console.log(error));
    },
    */
    getAfspraken() {
      axios
        .get("https://hofman.weblion.be/api/bestellingen/")
        .then((response) => {
          this.weekTitle = "week " + moment().week();
          this.currentWeek = moment().week();

          this.afspraken = response.data;

          this.weekAgenda(this.currentWeek);
          console.log(this.agenda);
        });
    },
    /*
    previousWeek() {
      this.currentWeek = this.currentWeek - 1;
      this.weekTitle = "week " + this.currentWeek;
      let weekArr = [];
      for (var i = 0; i < this.afspraken.length; i++) {
        let ophalingsdatum = moment(this.afspraken[i]["ophalingsdatum"]);
        let leveringsdatum = moment(this.afspraken[i]["leveringsdatum"]);
        let afspraak = _.cloneDeep(this.afspraken[i]);
        //week

        if (
          moment(ophalingsdatum).isBetween(
            moment()
              .day("Monday")
              .week(this.currentWeek)
              .startOf("week"),
            moment()
              .day("Monday")
              .week(this.currentWeek)
              .endOf("week")
          )
        ) {
          let afspraak1 = _.cloneDeep(afspraak);
          afspraak1.type = "ophaling";
          afspraak1.tijdstip = moment(
            afspraak1.ophalingsdatum + " " + afspraak1.ophalingsrichtuur
          );
          weekArr.push(afspraak1);
        }

        if (
          moment(leveringsdatum).isBetween(
            moment()
              .day("Monday")
              .week(this.currentWeek)
              .startOf("week"),
            moment()
              .day("Monday")
              .week(this.currentWeek)
              .endOf("week")
          )
        ) {
          let afspraak1 = _.cloneDeep(afspraak);
          afspraak1.type = "levering";
          afspraak1.tijdstip = moment(
            afspraak1.leveringsdatum + " " + afspraak1.leveringsrichtuur
          );
          weekArr.push(afspraak1);
        }
      }

      this.week = weekArr;

      this.week.sort(function(a, b) {
        return a.tijdstip - b.tijdstip;
      });
    },
    */
    previousWeek() {
      this.currentWeek = this.currentWeek - 1;
      this.weekAgenda(this.currentWeek);
    },
    nextWeek() {
      this.currentWeek = this.currentWeek + 1;
      this.weekAgenda(this.currentWeek);
    },
    /*
    nextWeek() {
      this.currentWeek = this.currentWeek + 1;
      this.weekTitle = "week " + this.currentWeek;
      let weekArr = [];
      for (var i = 0; i < this.afspraken.length; i++) {
        let ophalingsdatum = moment(this.afspraken[i]["ophalingsdatum"]);
        let leveringsdatum = moment(this.afspraken[i]["leveringsdatum"]);
        let afspraak = _.cloneDeep(this.afspraken[i]);
        //week

        if (
          moment(ophalingsdatum).isBetween(
            moment()
              .day("Monday")
              .week(this.currentWeek)
              .startOf("week"),
            moment()
              .day("Monday")
              .week(this.currentWeek)
              .endOf("week")
          )
        ) {
          let afspraak1 = _.cloneDeep(afspraak);
          afspraak1.type = "ophaling";
          afspraak1.tijdstip = moment(
            afspraak1.ophalingsdatum + " " + afspraak1.ophalingsrichtuur
          );
          weekArr.push(afspraak1);
        }

        if (
          moment(leveringsdatum).isBetween(
            moment()
              .day("Monday")
              .week(this.currentWeek)
              .startOf("week"),
            moment()
              .day("Monday")
              .week(this.currentWeek)
              .endOf("week")
          )
        ) {
          let afspraak1 = _.cloneDeep(afspraak);
          afspraak1.type = "levering";
          afspraak1.tijdstip = moment(
            afspraak1.leveringsdatum + " " + afspraak1.leveringsrichtuur
          );
          weekArr.push(afspraak1);
        }
      }

      this.week = weekArr;

      this.week.sort(function(a, b) {
        return a.tijdstip - b.tijdstip;
      });
    },
    */
    getContainers() {
      axios
        .get("https://hofman.weblion.be/api/containers/")
        .then((response) => {
          this.containers = response.data;
        });
    },
    getVrachtwagens() {
      axios
        .get("https://hofman.weblion.be/api/vrachtwagens/")
        .then((response) => {
          this.vrachtwagens = response.data;
        });
    },
    getChauffeurs() {
      axios
        .get("https://hofman.weblion.be/api/chauffeurs/")
        .then((response) => {
          this.chauffeurs = response.data;
        });
    },
    getWerven() {
      axios.get("https://hofman.weblion.be/api/werven/").then((response) => {
        this.werven = response.data;
      });
    },
    updateBestelling() {
      axios
        .put("https://hofman.weblion.be/api/bestellingen/", {
          bestelling: this.bestelling,
        })
        .then((response) => {
          this.getAfspraken();
          if (response.status == "200") {
            $("#overzichtModal").modal("hide");
          }
          console.log(response);
        })
        .catch(function(error) {
          console.log(error);
        });
    },
  },
};
</script>

<style>
html,
body,
#app {
  height: 100%;
}

.weekDayDate {
  font-size: 13px;
}

button {
  margin-right: 10px;
}

.date {
  margin-left: 6px;
  color: #999;
}

.sub-info {
  color: #999;
}

.table thead th {
  text-align: left !important;
}

.pager ul {
  list-style-type: none;
}

.pager ul li {
  display: inline-block;
  border: 1px solid #dee2e6;
  border-radius: 3px;
  padding: 5px;
  width: 40px;
  text-align: center;
  margin: 2px;
}

.modal input,
.modal select {
  margin-bottom: 5px;
}

.modal-body label {
  display: inline-block;
  width: 32%;
}

.modal-body .form-control {
  display: inline-block;
  width: 68%;
}

.modal-body select {
  text-indent: 5px;
}

#exampleModal input {
  display: block;
  width: 100%;
}

.dropdown {
  display: inline-block;
}

.dropdown-item:hover {
  cursor: pointer !important;
}

.dropdown-item i {
  margin-right: 3px;
}

/*
.sticky-nav {
  position: fixed;
  height: 150px;
  top: 50;
  z-index: 2;
  background: white;
  padding-top: 10px;
  width: 100%;
  margin-top: -10px;
}
*/

.o-item:hover {
  cursor: pointer;
}

.vgt-wrap {
  margin-top: 120px;
}

label {
  vertical-align: top;
}

[data-g="1"] {
  background: #8cc040;
}

[data-g="0"] {
  background: red;
}

.vue__time-picker input.display-time.disabled,
.vue__time-picker input.display-time:disabled {
  background-color: #e9ecef;
  color: #495057;
}

.form-control:disabled,
.form-control[readonly] {
  -webkit-appearance: none;
  appearance: none;
}

#bestellingModal textarea {
  height: 100px;
}

#agenda .col {
  padding: 5px;
}

.o-item {
  font-size: 14px;
}

#agenda .week {
  height: auto;
}

#agenda {
  margin-top: 0 !important;
}
</style>
